import { computed } from 'mobx';

export default class TemplateModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.updateFromJson(item);
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      description: this.description,
      topics: this.topics || [],
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.description = json.description;
    this.topics = json.topics || [];
  }
}



// WEBPACK FOOTER //
// ./src/models/Maintenance/Survey/TemplateModel.js